<template>
    <div>
        <div class="flex flex-between flex-v-center">
            <el-page-header @back="goBack" title="">
                <div slot="content" class="flex flex-v-center" v-if="source">
                    <h2><span class="color-primary">{{ source_index + 1 }}</span> / {{ list.length }}
                    </h2>

                    <div class="margin-l" style="width: 200px;">

                    </div>
                </div>
            </el-page-header>




            <div class="flex flex-v-center">


                <el-dropdown class="margin-r" v-if="favorites.length > 0 && source" @command="addMineFavorite"
                    slot="content" placement="bottom">
                    <i class="el-icon-plus pointer"
                        :class="{ 'color-primary': source.mines && source.mines.length > 0 }"
                        :style="{ color: $store.state.theme == 'dark' ? '#fff' : '#333' }" style="font-size: 30px;"></i>
                    <el-dropdown-menu>
                        <el-dropdown-item disabled>
                            <div style="color: #ccc;" class="center">
                                {{ $t('添加到收藏夹') }}
                            </div>
                        </el-dropdown-item>
                        <el-dropdown-item :divided="index == 0" :command="item.id" v-for="(item, index) in favorites"
                            :key="index">
                            <div class="flex flex-v-center flex-between"
                                :class="{ 'bold color-primary': source.mines && source.mines.find(v => v.favorite_id == item.id) }">
                                {{
                                    item.title
                                }}
                                <i class="el-icon-check margin-ls"
                                    v-if="source.mines && source.mines.find(v => v.favorite_id == item.id)"></i>
                            </div>
                        </el-dropdown-item>


                    </el-dropdown-menu>
                </el-dropdown>

                <el-tooltip placement="top" v-if="setting.mode != '听力模式'" :content="$t('练习记录')" class="margin-r">
                    <i @click="showRecord()" style="font-size: 30px;" class="el-icon-date pointer"></i>
                </el-tooltip>

                <el-tooltip placement="top" v-if="setting.mode == '听力模式'" :content="$t('自动下一句')" class="margin-r">
                    <i :style="{ color: setting.auto ? '#e6a13c' : '' }" @click="setting.auto = !setting.auto"
                        style="font-size: 30px;" class="pointer el-icon-video-play"></i>
                </el-tooltip>


                <el-tooltip placement="top" v-if="setting.mode != '听力模式'" :content="$t('练习结算')" class="margin-r">
                    <i @click="dialogVisible = true" style="font-size: 30px;" class="el-icon-data-line pointer"></i>
                </el-tooltip>
                <el-tooltip v-if="setting.mode != '听力模式'" placement="top" :content="$t('音效') + '：' + setting.voice"
                    class="margin-r">
                    <i @click="set_voice()" style="font-size: 30px;"
                        :class="setting.voice == '开启' ? 'el-icon-bell' : 'el-icon-close-notification'"
                        class=" pointer"></i>
                </el-tooltip>
                <el-tooltip v-if="setting.mode == '听写模式'" placement="top"
                    :content="$t('音频重复') + '：' + setting.times + '次'" class="margin-r">
                    <el-dropdown trigger="click" placement="bottom" @command="set_times">
                        <i style="font-size: 30px;" class="el-icon-headset pointer"></i>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item :command="times" v-for="times in [1, 2, 3, 4, 5, 6, 7]" :key="times">
                                <h3 :class="{ 'color-primary': setting.times == times }">{{ times }}次</h3>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>

                </el-tooltip>

                <el-tooltip v-if="setting.mode == '听写模式'" placement="top"
                    :content="$t('音频倍速') + '：' + setting.speed + 'x'" class="margin-r">
                    <el-dropdown trigger="click" placement="bottom" @command="set_speed">
                        <i style="font-size: 30px;" class="el-icon-stopwatch  pointer"></i>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item :command="speed" v-for="(speed, i) in [0.75, 1.0, 1.25, 1.5, 1.75, 2.0]"
                                :key="i">
                                <h3 :class="{ 'color-primary': setting.speed == speed }">{{ speed }}x</h3>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>

                </el-tooltip>

                <el-tooltip placement="top" :content="$t('练习列表')">
                    <i style="font-size: 30px;" @click="dialogVisible1 = true"
                        class="el-icon-document margin-r pointer"></i>
                </el-tooltip>


                <el-tooltip placement="top" :content="$t('题目设置')">
                    <i style="font-size: 30px;" @click="get_data(true)" class="el-icon-notebook-2 margin-r pointer"></i>
                </el-tooltip>

                <el-tooltip placement="top" :content="$t('练习模式')">
                    <i style="font-size: 30px;" @click="get_setting()" class="el-icon-setting margin-r pointer"></i>
                </el-tooltip>
                <i style="font-size: 30px;" class="el-icon-timer"></i>
                <h3 style="letter-spacing: 2px;margin-left: 10px;"> <span>{{ timeText }}</span></h3>
            </div>
        </div>

        <div class="margin-t" v-if="list.length > 0">
            <el-progress :show-text="false" :percentage="(source_index + 1) / list.length * 100"></el-progress>
        </div>

        <div v-loading="loading" class="game flex flex-column flex-v-center flex-h-center flex-between padding"
            style="min-height: 75vh;">
            <div v-if="source">
                <h3 class="center">{{ source.title }} #{{ source.no }}</h3>
            </div>

            <div v-if="setting.mode == '听力模式'" class="margin-lt flex flex-v-center" style="gap: 10px;">
                <template v-for="(key, i) in settingKeys">
                    <el-button-group :key="`e${i}`">
                        <el-button @click="setKeyIndex(i)" :disabled="!setting[key].enable" :plain="keyIndex > i"
                            :type="keyIndex >= i ? 'primary' : 'default'" round><i
                                :class="keyIndex == i ? 'el-icon-loading' : (setting[key].enable ? (keyIndex > i ? 'el-icon-success' : 'el-icon-video-play') : 'el-icon-close')"></i>
                            {{ $t(key) }} x {{ setting[key].times }}<span style="display: inline-block;width: 30px;">({{
                                setting[key].speed }}x)</span>
                        </el-button>
                        <el-button @click="setSettingKey(key)" :plain="keyIndex > i"
                            :type="keyIndex >= i ? 'primary' : 'default'" round>
                            <i class="el-icon-setting"></i>
                        </el-button>
                    </el-button-group>
                    <div :key="`d${i}`" v-if="i < settingKeys.length - 1"
                        style="height: 1px;width:40px;background-color: #ccc;"></div>
                </template>
            </div>
            <template v-if="setting.mode == '听力模式'">
                <div class="margin-lt" style="height: 240px;">
                    <el-card v-if="settingKey" class="box-card" style="width: 300px;">
                        <div slot="header" class="flex flex-between flex-v-center">
                            <span>{{ $t(settingKey + '设置') }}</span>
                            <i @click="setSettingKey('')" class="el-icon-close"></i>
                        </div>
                        <div class="flex flex-v-center flex-between">
                            <h4>{{ $t('启用') }}</h4>
                            <el-switch v-model="setting[settingKey].enable" active-color="#e6a13c"
                                inactive-color="#ccc"></el-switch>
                        </div>
                        <div style="height: 1px;width:100%;background-color: #ccc;margin: 10px 0"></div>
                        <div class="flex flex-v-center flex-between">
                            <h4>{{ $t('次数') }}</h4>
                            <div style="flex:1" class="margin-x">
                                <el-slider v-model="setting[settingKey].times" :min="1" :max="5"></el-slider>
                            </div>
                            <div style="width: 40px;" class="center">
                                {{ setting[settingKey].times }}
                            </div>
                        </div>
                        <div class="flex flex-v-center flex-between">
                            <h4>{{ $t('速度') }}</h4>
                            <div style="flex:1" class="margin-x">
                                <el-slider v-model="setting[settingKey].speed" :min="0.75" :step="0.25"
                                    :max="2"></el-slider>
                            </div>
                            <div style="width: 40px;" class="center">
                                {{ setting[settingKey].speed }}x
                            </div>
                        </div>
                    </el-card>
                </div>
            </template>
            <div v-if="setting.mode != '听力模式' && !doneFlag" :style="{ opacity: answerFlag ? 1 : 0 }"
                class="margin-lt flex margin-b padding flex-h-center"
                style="gap: 15px; flex-wrap: wrap;border-radius: 10px;background-color: #e6a13c;color:#fff;position: relative;">
                <div v-for="(word, i) in words" :key="i" style="text-align: center;">
                    <h4>{{ word.phonetic }}</h4>
                    <h4>{{ word.word }}</h4>
                    <el-tag class="margin-ts" size="mini">{{ word.pos }}</el-tag>
                    <div style="font-size: 14px;" class="margin-ts">{{ word.meaning }}</div>
                </div>

                <div @click="answerFlag = false"
                    style="position: absolute;top:-10px;right:-10px;background-color: #ccc;border-radius: 50%;width: 20px;height: 20px;"
                    class="flex flex-v-center flex-h-center">
                    <i class="el-icon-close pointer"></i>
                </div>
            </div>

            <div v-if="setting.mode == '中译英模式' || doneFlag" class="margin-t">
                <h2 class="center">{{ meaning }}</h2>
            </div>



            <div :style="{ height: setting.mode == '听力模式' ? 'auto' : '200px' }" class="flex flex-v-center flex-h-center"
                style="gap: 20px; flex-wrap: wrap;">
                <div :class="{ 'shake': shakeFlag && word.input != word.word }" class="pointer"
                    v-for="(word, i) in words" :key="i" @click="setIndex(i)">
                    <div class="center margin-b" v-if="doneFlag">
                        <el-tag>
                            <h2>{{ word.phonetic }}</h2>
                        </el-tag>
                    </div>
                    <h2 class="center" style="color:transparent;">{{ word.word }}</h2>
                    <h2 v-if="setting.mode != '听力模式'" :style="{ color: word.color }"
                        style="height: 40px; line-height: 40px;position: relative;z-index: 2;margin-top: -40px;"
                        class="center">{{
                            word.input }}
                    </h2>
                    <h2 v-if="setting.mode == '听力模式'" :style="{ color: keyIndex > 1 ? word.color : 'transparent' }"
                        style="height: 40px; line-height: 40px;position: relative;z-index: 2;margin-top: -40px;"
                        class="center">{{
                            word.word }}
                    </h2>
                    <div v-if="setting.mode != '听力模式'"
                        :style="{ backgroundColor: index == i ? '#e6a13c' : (word.color || ($store.state.theme == 'dark' ? '#fff' : '#999')), height: index == i ? '4px' : '2px' }">
                    </div>
                    <div class="center margin-ts" v-if="doneFlag || setting.mode == '中译英模式'">
                        <el-tag size="small">{{ word.pos }}</el-tag>
                    </div>

                    <h4 class="center margin-t" v-if="doneFlag || setting.mode == '听力模式'"
                        :style="{ color: (setting.mode == '听力模式' && keyIndex < 2) ? 'transparent' : word.color }">{{
                            word.meaning }}
                    </h4>
                </div>
            </div>

            <div class="flex flex-v-center" style="gap: 40px;margin-top: 80px;">

                <el-tooltip placement="top">
                    <div slot="content">
                        {{ $t('上一题') }}</div>
                    <i @click="prev_source()" :style="{ 'color': source_index > 0 ? '#e6a23c' : '#999' }"
                        class="el-icon-d-arrow-left pointer" style="font-size: 40px;font-weight: bold;"></i>
                </el-tooltip>
                <el-tooltip :disabled="section_index == 0" placement="top" v-if="setting.level != '高级'">
                    <div slot="content"><el-tag size="small">Ctrl</el-tag> + <el-tag size="small">p</el-tag> 上一句</div>
                    <i @click="prev()" :style="{ color: section_index > 0 ? '#e6a23c' : '#999' }"
                        class="el-icon-arrow-left pointer" style="font-size: 40px;font-weight: bold;"></i>
                </el-tooltip>

                <div class="flex flex-between flex-v-center" style="gap: 40px;">
                    <!-- <el-button v-if="setting.mode != '听力模式'" :disabled="index == -1" class="flex flex-v-center pointer"
                        @click="playType(2)" type="primary" round style="gap: 5px;">
                        <el-tag size="mini">Ctrl</el-tag> + <el-tag size="mini">w</el-tag> {{ $t('播放单词') }}
                    </el-button> -->

                    <el-button v-if="setting.mode != '听力模式'" :disabled="!source || doneFlag"
                        class="flex flex-v-center pointer" @click="playWords(1)" type="primary" round style="gap: 5px;">
                        <el-tag size="mini">Ctrl</el-tag> + <el-tag size="mini">a</el-tag> {{ $t('播放音频') }}
                    </el-button>

                    <div v-if="setting.mode != '听力模式'" @click="show_answer()">
                        <el-button :disabled="!source || doneFlag" class="flex flex-v-center pointer" type="primary"
                            round style="gap: 5px;">
                            <el-tag size="mini">Ctrl</el-tag> + <el-tag size="mini">v</el-tag> {{ $t('查看答案') }}
                        </el-button>
                    </div>

                    <el-button v-if="setting.mode != '听力模式'" :disabled="!source || source_index == list.length - 1"
                        @click="submit()" class="flex flex-v-center" type="primary" round style="gap: 5px;">
                        <el-tag size="mini">Enter</el-tag> {{ doneFlag ? $t('下一题') : $t('提交') }}
                    </el-button>

                </div>

                <el-tooltip :disabled="section_index == sections.length - 1" placement="top"
                    v-if="setting.level != '高级'">
                    <div slot="content"><el-tag size="small">Ctrl</el-tag> + <el-tag size="small">n</el-tag>
                        {{ nextLabel }}</div>
                    <i @click="next(1)" :style="{ 'color': section_index == sections.length - 1 ? '#999' : '#e6a23c' }"
                        class="el-icon-arrow-right pointer" style="font-size: 40px;font-weight: bold;"></i>
                </el-tooltip>

                <el-tooltip placement="top">
                    <div slot="content"> {{ $t('下一题') }}</div>
                    <i @click="next_source()" :style="{ 'color': source_index < list.length - 1 ? '#e6a23c' : '#999' }"
                        class="el-icon-d-arrow-right  pointer" style="font-size: 40px;font-weight: bold;"></i>
                </el-tooltip>
            </div>

            <audio ref="audio" preload="metadata" @ended="playEnded()" style="display:none">
                浏览器太老咯，请升级浏览器吧~
            </audio>

            <audio v-for="i in audioCount" :key="i" :ref="'audio' + i" preload="metadata" style="display:none">
                浏览器太老咯，请升级浏览器吧~
            </audio>


        </div>

        <el-dialog :show-close="source_index < list.length - 1 || doneFlag" :close-on-click-modal="false"
            :close-on-press-escape="false" v-if="dialogVisible" width="60%" center :visible.sync="dialogVisible">
            <el-descriptions :colon="false" border label-class-name="center" content-class-name="center"
                direction="vertical" class="margin-top" :column="3">
                <el-descriptions-item :span="3">
                    <div slot="label" class="flex flex-between flex-v-center">
                        <h2>{{ $t('练习结算') }}</h2>
                        <el-link @click="showSource()">共练习{{ source_index + 1 }}题<i
                                class="el-icon-arrow-right"></i></el-link>
                    </div>
                    <div class="flex flex-between">
                        <div class="flex flex-v-center">
                            <i class="el-icon-trophy color-primary bold" style="font-size: 40px;"></i>
                            <h1 class="margin-l">{{ rank }}</h1>
                        </div>

                        <div class="flex flex-v-center" style="gap: 30px;">
                            <div class="text-center">
                                <h1>{{ perfectCount }}</h1>
                                <div style="color: #999;">{{ $t('完美') }}</div>
                            </div>

                            <div class="text-center">
                                <h1>{{ goodCount }}</h1>
                                <div style="color: #999;">{{ $t('很好') }}</div>
                            </div>

                            <div class="text-center">
                                <h1>{{ skipCount }}</h1>
                                <div style="color: #999;">{{ $t('跳过') }}</div>
                            </div>
                        </div>
                    </div>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-timer color-primary" style="font-size: 20px;"></i>
                        <h4>{{ $t('用时时长') }}</h4>
                    </template>
                    <h2> {{ timeStr }}</h2>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-reading color-primary" style="font-size: 20px;"></i>
                        <h4>{{ $t('答题数') }}</h4>
                    </template>
                    <h2>{{ source_index + 1 }}</h2>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-magic-stick color-primary" style="font-size: 20px;"></i>
                        <h4>{{ $t('最大连击') }}</h4>
                    </template>
                    <h2>{{ maxPerfectCount }}</h2>

                </el-descriptions-item>
            </el-descriptions>


            <el-descriptions :colon="false" label-class-name="center" content-class-name="center" direction="vertical"
                class="margin-t" :column="4">
                <el-descriptions-item>
                    <template slot="label">
                        <el-progress :width="100" type="circle"
                            :color="(submitCount > 0 && perfectCount / submitCount == 1) ? 'green' : (perfectCount / submitCount >= 0.6 ? '#e6a23c' : 'red')"
                            :percentage="submitCount == 0 ? 0 : parseInt(perfectCount / submitCount * 100)"></el-progress>
                    </template>
                    {{ $t('一次命中率') }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <el-progress :width="100" type="circle"
                            :color="perfectCount / wordCount == 1 ? 'green' : (perfectCount / wordCount >= 0.6 ? '#e6a23c' : 'red')"
                            :percentage="wordCount == 0 ? 0 : parseInt(perfectCount / wordCount * 100)"></el-progress>
                    </template>
                    {{ $t('正确率') }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <el-progress :width="100" type="circle" :color="answerCount == 1 ? '#e6a23c' : 'red'"
                            :define-back-color="answerCount == 0 ? 'green' : '#f0f0f0'"
                            :percentage="wordCount == 0 ? 0 : parseInt(answerCount / wordCount * 100)"></el-progress>
                    </template>
                    {{ $t('查看答案') }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <el-progress :width="100" :format="() => playCount + '次'" type="circle"
                            :color="playCount == 1 ? '#e6a23c' : 'red'"
                            :define-back-color="playCount == 0 ? 'green' : '#f0f0f0'"
                            :percentage="wordCount == 0 ? 0 : parseInt(playCount / wordCount * 100)"></el-progress>
                    </template>
                    {{ $t('重听次数') }}

                </el-descriptions-item>

            </el-descriptions>

            <div slot="footer"
                v-if="doneFlag && section_index == sections.length - 1 && source_index == list.length - 1">
                <el-button v-if="filterData.page > 1" type="primary" class="margin-x" @click="prevPage()" round><i
                        class="el-icon-back"></i>{{
                            $t('上一组') }}</el-button>
                <el-button class="margin-x" plain type="primary" @click="reTry()" round>{{ $t('再来一次') }}<i
                        class="el-icon-refresh-right"></i></el-button>
                <el-button v-if="filterData.page < lastPage" class="margin-x" type="primary" @click="nextPage()"
                    round>{{
                        $t('下一组')
                    }}<i class="el-icon-right"></i></el-button>
            </div>
        </el-dialog>


        <el-dialog width="65%" center @close="close()" :visible.sync="dialogVisible1">

            <div slot="title" class="center">
                <h3>{{ dialogFlag ? ($t('共练习') + (source_index + 1) + $t('题')) : ($t('练习列表') + ' (' +
                    filterData.pageSize + '/'
                    + total + ')') }}</h3>
                <el-pagination v-if="!dialogFlag" class="margin-t" background :current-page="filterData.page"
                    @current-change="pageChange" layout="prev, pager, next, jumper" :pageSize="filterData.pageSize"
                    :total="total">
                </el-pagination>
            </div>
            <div style="margin-top:-25px; max-height: 50vh;min-height: 20vh; overflow-y: scroll;" v-loading="loading">
                <el-table :show-header="last_source_index != -1" :data="list">
                    <el-table-column>
                        <div slot="header" class="flex flex-between flex-v-center"
                            v-if="list.length > 1 && last_source_index != -1">
                            <div class="color-primary">{{ $t('上次练习到') }}: #{{ list[last_source_index].no }} {{
                                list[last_source_index].words_en
                            }}
                            </div>
                            <!-- <el-button @click="dialogVisible1 = false" size="small" type="primary">{{ $t('继续练习') }}<i
                                    class="el-icon-right"></i></el-button> -->
                        </div>
                        <div @click="go(scope.$index)" slot-scope="scope" class="flex flex-between flex-v-center">
                            <h2 class="flex flex-v-center pointer" style="word-break: keep-all;"
                                :class="{ 'color-primary': source && source.id == scope.row.id }">
                                <el-tag size="small" type="primary">#{{
                                    scope.row.no }}</el-tag> <span class="margin-l">{{ scope.row.words_en }}</span>
                            </h2>
                            <template v-if="!dialogFlag">
                                <i v-if="source && source.id == scope.row.id" style="font-size: 20px;"
                                    class="el-icon-timer color-primary"></i>
                                <i v-else class="el-icon-right"></i>
                            </template>
                        </div>
                    </el-table-column>
                </el-table>
            </div>

            <div slot="footer" v-if="!dialogFlag">
                <template v-if="list.length > 1 && last_source_index != -1">
                    <el-button class="margin-r" @click="reTry()" round type="primary" plain icon="el-icon-refresh">{{
                        $t('重新开始')
                    }}</el-button>
                    <el-button class="margin-l" @click="dialogVisible1 = false" round type="primary">{{ $t('继续上次练习')
                        }}<i class="el-icon-right"></i></el-button>
                </template>

                <el-button v-else class="margin-l" @click="dialogVisible1 = false" round type="primary">{{ source_index
                    == -1 ?
                    $t('开始练习') : $t('继续练习')
                }}<i class="el-icon-right"></i></el-button>
            </div>

        </el-dialog>


        <el-dialog width="65%" center :title="$t('练习记录')" :visible.sync="dialogVisible4">
            <div style="max-height: 50vh;min-height: 20vh; overflow-y: scroll;">
                <el-table size="small" :show-header="false" :data="records">
                    <el-table-column>
                        <div @click="showData(scope.row.data)" slot-scope="scope"
                            class="flex flex-between flex-v-center">
                            <h1>{{ getRank(scope.row.data) }}</h1>
                            <div style="flex: 1;" class="margin-l">
                                <h2 class="flex flex-v-center flex-wrap" style="gap:10px;">
                                    <el-tag effect="dark" v-for="source in scope.row.sources" :key="source.id"
                                        size="small" type="primary">#{{
                                            source.no }}</el-tag>
                                </h2>

                                <div class="margin-t flex flex-v-center" style="gap: 10px;">
                                    <el-tag size="small">{{ $t('一次命中率')
                                        }}:{{ parseInt(scope.row.data.perfectCount /
                                            scope.row.data.submitCount * 100) }}%</el-tag>
                                    <el-tag size="small">{{ $t('正确率')
                                        }}:{{ parseInt(scope.row.data.perfectCount /
                                            scope.row.data.wordCount * 100) }}%</el-tag>
                                    <el-tag size="small">{{ $t('查看答案') }}:{{
                                        scope.row.data.answerCount }}</el-tag>
                                    <el-tag size="small">{{ $t('重听次数') }}:{{
                                        scope.row.data.playCount }}</el-tag>
                                    <div style="font-size: 14px;color: #999;"> {{ scope.row.updated_at }}</div>
                                </div>
                            </div>
                            <h2 class="color-primary">
                                {{ format_time(scope.row.data.time) }}
                            </h2>
                        </div>
                    </el-table-column>
                </el-table>
            </div>
            <div slot="footer" class="center" v-if="record_total > 0">
                <el-pagination background :current-page="record_page" @current-change="pageChange1"
                    layout="prev, pager, next, jumper" :pageSize="10" :total="record_total">
                </el-pagination>
            </div>
        </el-dialog>



        <el-dialog width="65%" top="5%" center :title="$t('题目设置')" :visible.sync="dialogVisible2">

            <el-card class="box-card" :body-style="{ padding: '10px' }">
                <div slot="header" class="clearfix flex flex-between flex-v-center">
                    <h3>{{ $t('题型库') }}：<span class="color-primary">{{ filterData1.tag }}</span></h3>
                    <el-radio-group v-model="filterData1.type">
                        <el-radio-button :label="item" v-for="(item, i) in ['全部', '预测']" :key="i">
                            {{ $t(item) }}
                        </el-radio-button>
                    </el-radio-group>
                </div>

                <div class="flex flex-v-center" style="gap: 40px; flex-wrap: wrap;">
                    <div v-for="(type, i) in types" :key="i" class="pointer" @click="filterData1.tag = type.tag"
                        :style="{ border: filterData1.tag == type.tag ? '2px solid #e6a13c' : '2px solid transparent', padding: '10px', borderRadius: '10px' }">
                        <img :src="$host + type.logo" style="width: 80px;height: 80px;">
                    </div>
                </div>
            </el-card>

            <el-card class="margin-t">
                <div slot="header" class="clearfix">
                    <h3>{{ $t('选择难度') }}：<span class="color-primary">{{ levels[filterData1.level] }}</span></h3>
                </div>
                <el-radio-group v-model="filterData1.level">
                    <el-radio-button :label="i" v-for="(item, i) in levels" :key="i">
                        {{ $t(item) }}
                    </el-radio-button>
                </el-radio-group>
            </el-card>

            <el-card class="box-card margin-t">
                <div slot="header" class="clearfix">
                    <h3>{{ $t('每组练习数量') }}：<span class="color-primary">{{ filterData1.pageSize }}</span></h3>
                </div>


                <el-radio-group v-model="filterData1.pageSize">
                    <el-radio-button v-for="(num, i) in pageSizes" :key="i" :label="num">
                        {{ $t(num) }}
                    </el-radio-button>
                </el-radio-group>

            </el-card>

            <div slot="footer" class="center">
                <el-button class="margin-r" round type="primary" @click="get_data(false)" plain icon="el-icon-close">{{
                    $t('取消')
                    }}</el-button>
                <el-button class="margin-l" round type="primary" @click="set_data()" icon="el-icon-finished">{{ $t('确定')
                    }}</el-button>
            </div>
        </el-dialog>


        <el-dialog width="65%" top="5%" center :title="$t('练习模式')" :visible.sync="dialogVisible3">


            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <h3>{{ $t('选择练习模式') }}：<span class="color-primary">{{ setting1.mode }}</span></h3>
                </div>
                <el-radio-group v-model="setting1.mode">
                    <el-radio-button label="中译英模式">{{ $t('中译英模式') }}</el-radio-button>
                    <el-radio-button label="听写模式">{{ $t('听写模式') }}</el-radio-button>
                    <el-radio-button label="听力模式">{{ $t('听力模式') }}</el-radio-button>
                </el-radio-group>


                <div class="margin-t">
                    <template v-if="setting1.mode == '中译英模式'">
                        {{ $t('看到中文提示，尝试用英文表达。练习运用所学词汇和语法。') }}
                    </template>
                    <template v-if="setting1.mode == '听写模式'">
                        {{ $t('听音频，写出你听到的英文单词，训练听力，掌握单词拼写。') }}
                    </template>
                    <template v-if="setting1.mode == '听力模式'">
                        {{ $t('每句经历盲听、慢听、字幕三个阶段，逐步揭示内容，深度训练听力理解。播放次数、音频倍速与各阶段流程可在练习中按需调整。') }}
                    </template>
                </div>
            </el-card>



            <el-card class="margin-t">
                <div slot="header" class="clearfix">
                    <h3>{{ $t('选择难度') }}：<span class="color-primary">{{ setting1.level }}</span></h3>
                </div>
                <el-radio-group v-model="setting1.level">
                    <el-radio-button label="初级">{{ $t('初级') }}</el-radio-button>
                    <el-radio-button label="中级">{{ $t('中级') }}</el-radio-button>
                    <el-radio-button label="高级">{{ $t('高级') }}</el-radio-button>
                </el-radio-group>
            </el-card>

            <div slot="footer" class="center">
                <el-button class="margin-r" round type="primary" @click="set_setting(1)" plain icon="el-icon-refresh">{{
                    $t('重新开始')
                    }}</el-button>
                <el-button class="margin-l" round type="primary" @click="set_setting()" icon="el-icon-video-play">{{
                    $t('继续练习')
                    }}</el-button>
            </div>
        </el-dialog>
    </div>

</template>
<script>
import moment from 'moment';
export default {
    name: 'Game',
    data() {
        return {
            dialogVisible: false,
            dialogFlag: false,
            dialogVisible1: false,
            dialogVisible2: false,
            dialogVisible3: false,
            dialogVisible4: false,
            words: [],
            list: [],
            sections: [],
            total: 9999,
            lastPage: 1,

            meaning: null,
            last_source_index: -1,
            index: -1,
            source: null,
            detail: null,
            answerFlag: false,
            answerFlag1: false,

            timer: null,
            timeText: "00:00:00",
            submitFlag: false,
            shakeFlag: false,
            checkFlag: false,
            doneFlag: false,
            loading: true,
            playFlag: false,
            submitTimes: 0,

            favorites: [],

            source_index: 0,
            section_index: 0,
            time: 0,
            maxPerfectCount: 0,
            maxPerfectTimes: 0,
            submitCount: 0,
            answerCount: 0,
            playCount: 0,
            perfectCount: 0,
            isPerfect: true,
            goodCount: 0,
            skipCount: 0,
            wordCount: 0,

            pageSizes: [5, 10, 15, 20],
            levels: ['简单', '中等', '困难', '全部'],
            filterData: {
                page: 1,
                tag: 'WFD',
                level: 3,
                type: '预测',
                pageSize: 20
            },
            filterData1: {
                tag: 'WFD',
                level: 3,
                type: '预测',
                pageSize: 20
            },
            settingKeys: ['盲听', '慢听', '字幕'],
            settingKey: '',
            keyIndex: -1,
            setting: {
                voice: '开启',
                mode: '中译英模式',
                level: '初级',
                speed: 1.0,
                times: 1,
                auto: false,
                "盲听": {
                    enable: true,
                    times: 2,
                    speed: 1,
                },
                "慢听": {
                    enable: true,
                    times: 2,
                    speed: 0.5,
                },

                "字幕": {
                    enable: true,
                    times: 2,
                    speed: 0.7,
                },
            },
            setting1: {
                mode: '中译英模式',
                level: '初级',
            },
            times: 0,
            audioCount: 3,
            audioIndex: 0, // 轮流播放索引,
            cacheKeys: [
                'source_index',
                'section_index',
                'time',
                'maxPerfectCount',
                'maxPerfectTimes',
                'submitCount',
                'answerCount',
                'playCount',
                'perfectCount',
                'isPerfect',
                'goodCount',
                'skipCount',
                'wordCount'
            ],
            records: [],
            record_total: 0,
            record_page: 1
        }
    },

    computed: {
        types: function () {
            // const types = ['WFD', 'SST', 'SWT']
            const types = ['WFD']
            return this.$store.getters.getTypes().filter(type => types.includes(type.tag))
        },

        rank: function () {
            if (this.submitCount == 0) return '-'
            let rate = this.perfectCount / this.submitCount * 100
            if (rate == 100) return 'SSS'
            else if (rate > 95) return 'SS'
            else if (rate > 90) return 'S'
            else if (rate > 80) return 'A'
            else if (rate > 70) return 'B'
            return 'C'
        },
        nextLabel: function () {
            if (this.sections.length == 0 || this.section_index == -1 || this.section_index == this.sections.length - 1) return ''
            else if (this.section_index == this.sections.length - 2) return '下一句子'
            else if (this.sections[this.section_index + 1].words.length > 1) return '下一短语'
            return '下一词'
        },
        timeStr: function () {
            return this.format_time(this.time)
        }
    },

    watch: {
        shakeFlag: function (newVal) {
            if (newVal) {
                setTimeout(() => {
                    this.shakeFlag = false
                }, 150);
            }
        },

        dialogVisible1: function (newVal) {
            if (!this.dialogFlag) {
                if (newVal) {
                    this.stopTimer()
                } else {
                    this.startTimer()
                }
            }
        },

        dialogVisible: function (newVal) {
            if (newVal) {
                this.stopTimer()
            } else {
                if (!this.doneFlag) {
                    this.startTimer()
                }
            }
        },
    },


    mounted() {
        if (this.$store.getters.getRole() == 0) {
            this.loading = false
            this.$vip_alert("此功能", '', () => {
                this.$router.replace('/main')
            })
            return;
        }
        if (localStorage.getItem('game_filter_data') != undefined) {
            const filterData = JSON.parse(localStorage.getItem('game_filter_data'))
            this.filterData = { ...this.filterData, ...filterData }
        }

        if (localStorage.getItem('game_setting') != undefined) {
            const setting = JSON.parse(localStorage.getItem('game_setting'))
            this.setting = { ...this.setting, ...setting }
        }
        this.get_cache()

        document.addEventListener('keydown', this.handleKeyDown)
        this.get_list(1);
        this.query_favorites()
    },
    beforeDestroy() {
        this.stopTimer();
        document.removeEventListener('keydown', this.handleKeyDown)

    },
    methods: {


        getRank: function (data) {
            if (data.submitCount == 0) return '-'
            let rate = data.perfectCount / data.submitCount * 100
            if (rate == 100) return 'SSS'
            else if (rate > 95) return 'SS'
            else if (rate > 90) return 'S'
            else if (rate > 80) return 'A'
            else if (rate > 70) return 'B'
            return 'C'
        },

        showData(data) {
            console.log(data)
        },

        format_time(time) {
            // 防止负数、小数，向下取整
            let sec = Math.floor(Math.max(time, 0));
            const min = Math.floor(sec / 60);
            const s = sec % 60;
            if (min === 0) {
                return `${s}s`;
            }
            return `${min}min ${s}s`;
        },

        setIndex(i) {
            if (this.doneFlag) return
            if (i < this.index) {
                this.submitFlag = false
            }
            this.index = i
        },
        showRecord() {
            this.dialogVisible4 = true
            this.get_records()
        },

        pageChange1(page) {
            this.record_page = page
            this.get_records()
        },

        get_records() {
            this.$http.post('/api/game/record/list', { page: this.record_page }).then(res => {
                this.records = res.data
                this.record_total = res.total
            })
        },
        addMineFavorite(id) {
            let source_id = 0
            let favorite_id = 0
            if (id.toString().indexOf(',') != -1) {
                let items = id.split(",");
                favorite_id = items[0]
                source_id = items[1];
            } else {
                favorite_id = id;
                source_id = this.source.id
            }
            this.$http.post("/api/source/mine", { favorite_id: favorite_id, source_id: source_id }).then(() => {
                let source = null;
                let index = -1;

                if (id.toString().indexOf(',') != -1) {

                    index = this.list.findIndex((val) => {
                        return val.id == source_id
                    })
                    source = this.list[index]
                } else {
                    source = this.source
                }
                if (source.mines) {
                    const index = source.mines.findIndex(v => v.favorite_id == favorite_id)
                    if (index == -1) {
                        source.mines.push({ favorite_id: favorite_id })
                        this.$message.success(this.$t("添加成功"))
                    } else {
                        source.mines.splice(index, 1)
                        this.$message.success(this.$t("取消成功"))
                    }
                } else {
                    source.mines = [{ favorite_id: favorite_id }]
                    this.$message.success(this.$t("添加成功"))
                }
                if (index != -1) {
                    this.$set(this.list, index, source)
                }
            })
        },

        query_favorites() {
            this.$http.post("/api/source/mine/favorite/list").then((favorites) => {
                this.favorites = favorites;
            })
        },

        showSource() {
            this.dialogFlag = true
            this.dialogVisible1 = true
        },

        remove_cache() {
            localStorage.removeItem('game_cache')
            this.source_index = 0
            this.section_index = 0
            this.time = 0
            this.maxPerfectCount = 0
            this.maxPerfectTimes = 0
            this.submitCount = 0
            this.answerCount = 0
            this.playCount = 0
            this.perfectCount = 0
            this.isPerfect = true
            this.goodCount = 0
            this.skipCount = 0
            this.wordCount = 0

            this.sections = []
            this.source = null
        },

        get_cache() {
            if (localStorage.getItem('game_cache') != undefined) {
                const data = JSON.parse(localStorage.getItem('game_cache'))
                this.cacheKeys.forEach(k => {
                    if (k === 'source_index') {
                        this.last_source_index = data[k]
                    } else {
                        this[k] = data[k]
                    }
                })
            }
        },

        set_cache() {
            const data = {}
            this.cacheKeys.forEach(k => {
                data[k] = this[k]
            })
            console.log(data)
            localStorage.setItem('game_cache', JSON.stringify(data))
            const status = this.dialogVisible ? 1 : 0
            const source_ids = this.dialogVisible ? this.list.map(v => v.id) : []
            this.$http.post('/api/game/record', { data, source_ids, status })
        },

        prevPage() {
            this.dialogVisible = false
            this.pageChange(this.filterData.page - 1)
        },

        reTry() {
            this.remove_cache()
            this.reDo(1)
        },

        nextPage() {
            this.dialogVisible = false
            this.pageChange(this.filterData.page + 1)
        },

        setKeyIndex(i) {
            this.settingKey = ''
            const lastKeyIndex = this.keyIndex
            this.keyIndex = i

            if (!this.setting[this.settingKeys[this.keyIndex]].enable && this.keyIndex < this.settingKeys.length - 1) {
                this.setKeyIndex(this.keyIndex + 1)
                return
            }
            this.times = this.setting[this.settingKeys[i]].times
            if (lastKeyIndex != -1 || lastKeyIndex == this.settingKeys.length) {
                setTimeout(() => {
                    this.playWords()
                }, 2000);
            } else {
                this.playWords()
            }
        },

        setSettingKey(key) {
            if (this.settingKey == key) {
                this.settingKey = ''
            } else {
                this.settingKey = key
            }
            if (!this.settingKey) {
                this.cache_setting()
            }
        },

        playEnded() {
            this.times--
            if (this.times > 0) {
                setTimeout(() => {
                    this.playWords()
                }, 1500);
            } else {
                if (this.setting.mode == '听力模式') {
                    if (this.keyIndex < this.settingKeys.length - 1) {
                        this.setKeyIndex(this.keyIndex + 1)
                    } else {
                        this.keyIndex = this.settingKeys.length
                        if (this.setting.auto) {
                            this.next()
                        }
                    }
                }
            }
        },

        set_voice() {
            if (this.setting.voice == '开启') {
                this.setting.voice = '关闭'
            } else {
                this.setting.voice = '开启'
            }
            this.cache_setting()
        },

        set_times(times) {
            this.setting.times = times
            this.cache_setting()
        },
        set_speed(speed) {
            this.setting.speed = speed
            this.cache_setting()
        },

        get_setting() {
            this.setting1 = { ...this.setting }
            this.dialogVisible3 = true
        },

        cache_setting() {
            localStorage.setItem('game_setting', JSON.stringify(this.setting))
        },

        set_setting(flag) {
            this.dialogVisible3 = false
            this.setting = { ...this.setting, ...this.setting1 }
            this.cache_setting()
            if (flag) {
                this.remove_cache()
            }
            this.reDo(1)
        },


        get_data(flag) {
            this.filterData1 = { ...this.filterData }
            this.dialogVisible2 = flag
        },

        set_data() {
            let flag = false
            const keys = Object.keys(this.filterData1)
            keys.forEach(k => {
                if (this.filterData1[k] != this.filterData[k]) {
                    flag = true
                }
            })
            if (flag) {
                this.filterData = { ...this.filterData1, page: 1 }
                this.remove_cache()
                this.get_list(1)
            }
            this.dialogVisible2 = false
        },

        goBack() {
            this.$router.back()
        },

        go(index) {
            if (this.dialogFlag) return
            if (index != undefined) {
                this.source_index = index
                this.section_index = 0
                this.last_source_index = -1
            }
            this.sections = []
            this.dialogVisible1 = false
        },

        close() {
            if (this.dialogFlag) {
                this.dialogFlag = false
                return
            }
            if (this.sections.length == 0) {
                if (this.last_source_index != -1) {
                    this.source_index = this.last_source_index
                    this.last_source_index = -1
                }
                this.reDo()
            }
        },

        pageChange(page) {
            if (page > this.lastPage) return
            this.filterData.page = page
            this.remove_cache()
            this.get_list(1)
        },




        reDo(flag) {
            this.dialogVisible1 = false
            this.dialogVisible = false
            this.index = 0
            this.submitFlag = false
            this.answerFlag = false
            this.doneFlag = false
            this.checkFlag = false
            this.submitTimes = 0
            if (flag) this.section_index = 0
            this.$refs.audio.pause()
            this.get_words();
        },

        getWidth(word) {
            const measureDom = document.createElement('span');
            measureDom.style.cssText = `
                font-weight:700;
                font-size:14px;
                visibility:hidden;
                position:absolute;
                white-space:nowrap;
                `;
            document.body.appendChild(measureDom);
            // 获取单词真实宽度
            measureDom.innerText = word;
            const width = measureDom.offsetWidth
            return width + 30
        },

        submit() {
            if (this.doneFlag) {
                this.next()
                return
            }
            if (this.checkFlag) return
            this.submitTimes++
            this.submitCount++
            this.checkFlag = true
            this.shakeFlag = true
            this.index = -1
            let flag = false
            this.words.forEach(word => {
                if (word.word.toLowerCase().split('/').includes(word.input.toLowerCase())) {
                    word.color = "green"
                } else {
                    word.color = "red"
                    flag = true
                }
            })
            this.submitFlag = true
            if (flag) {
                this.playType(0)
            } else {
                this.stopTimer()
                this.doneFlag = true
                this.answerFlag = false
                this.playType(1)
                this.playWords()
                if (this.submitTimes == 1) {
                    this.perfectCount++
                    if (this.isPerfect) {
                        this.maxPerfectTimes++
                        this.maxPerfectCount = Math.max(this.maxPerfectCount, this.maxPerfectTimes)
                    }
                    this.isPerfect = true
                } else {
                    this.maxPerfectTimes = 0
                    this.isPerfect = false
                }

                if (this.submitTimes == 2) {
                    this.goodCount++
                }

                if (this.source_index == this.list.length - 1 && this.section_index == this.sections.length - 1) {
                    this.dialogVisible = true

                }
            }
            this.set_cache()
        },

        prev() {
            if (this.section_index == 0) return
            this.section_index--
            this.refresh()
        },

        prev_source() {
            if (this.source_index > 0) {
                this.source_index--
                this.reDo(1)
            }
        },

        next_source() {
            if (this.source_index < this.list.length - 1) {
                this.source_index++
                this.reDo(1)
            }
        },

        next(flag) {
            if (this.section_index == this.sections.length - 1) {
                if (flag) return
                if (this.source_index == this.list.length - 1) {
                    if (this.setting.mode == '听力模式') {
                        this.pageChange(this.filterData.page + 1)
                    } else {
                        this.nextPage()
                    }
                } else {
                    this.next_source()
                }
                return
            }
            this.section_index++
            if (flag && !this.doneFlag) this.skipCount++
            this.refresh()
        },

        refresh() {
            this.$refs.audio.pause()
            this.doneFlag = false
            this.answerFlag = false
            this.keyIndex = -1
            this.submitTimes = 0
            this.playFlag = false
            this.answerFlag1 = false
            const section = this.sections[this.section_index]
            this.meaning = section.meaning
            this.words = section.words.map(v => ({ ...v, input: '', color: '' }))
            this.startTimer()
            if (this.setting.mode != '听力模式') this.wordCount++
            if (this.setting.mode == '听力模式') {
                this.setKeyIndex(0)
            } else {
                this.times = this.setting.times
                this.playWords();
            }
        },

        startTimer() {
            this.stopTimer()
            this.timer = setInterval(() => {
                this.time++;
                // 格式化时间 00:00:00
                let h = parseInt(this.time / 3600)
                    .toString()
                    .padStart(2, "0");
                let m = parseInt((this.time % 3600) / 60)
                    .toString()
                    .padStart(2, "0");
                let s = parseInt(this.time % 60)
                    .toString()
                    .padStart(2, "0");
                this.timeText = `${h}:${m}:${s}`;
            }, 1000);
        },

        stopTimer() {
            if (this.timer) clearInterval(this.timer);
            this.timer = null
        },

        copyChannels(buffers) {
            buffers.forEach((buffer, index) => {
                if (buffer.numberOfChannels == 1) {
                    let audioBuffer = new AudioBuffer({ length: buffers[index].length, numberOfChannels: 2, sampleRate: buffers[index].sampleRate });
                    const anotherArray = new Float32Array(buffers[index].length)
                    buffers[index].copyFromChannel(anotherArray, 0, 0)
                    audioBuffer.copyToChannel(anotherArray, 0, 0)
                    audioBuffer.copyToChannel(anotherArray, 1, 0)
                    buffers[index] = audioBuffer;
                }
            });
            return buffers;
        },

        playWords(flag) {
            if (flag && !this.playFlag) {
                this.playFlag = true
                this.playCount++
            }
            if (this.section_index == this.sections.length - 1) {
                this.$refs.audio.src = this.$host + "/api/audio/" + this.source.no + "/Andy?v=" + + moment().format('MMDDHHmm');
            } else {
                if (this.words.length == 1) {
                    this.$refs.audio.src = this.$host + "/api/word/audio/" + this.words[0].word + '/1';
                } else {
                    this.$refs.audio.src = this.$host + "/api/word/audio/" + this.words.map(v => v.word).join(' ') + '/0';
                }
            }

            this.$refs.audio.currentTime = 0
            this.$nextTick(() => {
                if (this.setting.mode == '听力模式') {
                    this.$refs.audio.playbackRate = this.setting[this.settingKeys[this.keyIndex]].speed
                } else {
                    this.$refs.audio.playbackRate = this.setting.speed
                }

                this.$refs.audio.play();
            })

        },

        setPrevIndex() {
            for (let i = this.index - 1; i >= 0; i--) {
                if (this.words[i].color != 'green') {
                    this.index = i;
                    break;
                }
            }
        },

        setNextIndex() {

            if (this.setting.mode == '听力模式') {
                this.setKeyIndex(0)
                return
            }

            if (this.index == this.words.length - 1 || this.words.findLastIndex(v => v.color != 'green') == this.index) {
                this.submit()
                return
            }

            for (let i = this.index + 1; i < this.words.length; i++) {
                if (this.words[i].color != 'green') {
                    this.index = i;
                    if (this.submitFlag) {
                        this.words[this.index].input = ''
                    }
                    break;
                }
            }
        },
        playType(flag) {
            if (flag !== 2 && this.setting.voice == '关闭') {
                return
            }
            let src = '/web/audio/type.mp3'
            if (flag === 2) {
                src = this.$host + "/api/word/audio/" + this.words[this.index].word + '/1';
            } else if (flag === 1) {
                src = '/web/audio/success.mp3'
            } else if (flag === 0) {
                src = '/web/audio/fail.mp3'
            }



            this.audioIndex = (this.audioIndex + 1) % this.audioCount
            const audio = this.$refs[`audio${this.audioIndex + 1}`][0]
            audio.src = src
            audio.currentTime = 0
            audio.play().catch(err => { console.log(err) }) // 防报错
        },

        handleKeyDown(e) {
            if (this.dialogVisible1) return
            if (this.doneFlag) {
                if (e.code == 'Enter' || e.code == 'Space') {
                    this.next()
                }
                return
            }
            if (e.code != 'Enter') {
                this.checkFlag = false
            }
            if (e.code == 'Space') {
                this.setNextIndex()
            } else if (e.code == 'Backspace') {
                if (this.index == -1) {
                    this.index = this.words.findIndex(v => v.input.toLowerCase() != v.word.toLowerCase())
                    this.words[this.index].input = ''
                    return
                }
                if (this.words[this.index].input) {
                    this.words[this.index].input = this.words[this.index].input.slice(0, -1);
                } else {
                    this.setPrevIndex()
                }
                this.playType()
            } else if (e.code == 'Enter') {
                this.submit()
            } else if (e.ctrlKey) {
                if (e.key == "a") {
                    this.playWords();
                } else if (e.key == "v") {
                    this.show_answer()
                } else if (e.key == "n") {
                    this.next(1)
                } else if (e.key == "p") {
                    this.prev()
                }
            } else if (/^[A-Za-z0-9\-']$/.test(e.key)) {
                if (this.index == -1) {
                    this.index = this.words.findIndex(v => v.input.toLowerCase() != v.word.toLowerCase())
                    if (this.index == -1) return
                    this.words[this.index].input = ''
                }
                this.words[this.index].input += e.key;
                this.words[this.index].color = ""
                this.playType()
            }
            e.preventDefault()
        },

        show_answer() {
            this.answerFlag = !this.answerFlag
            if (this.answerFlag && !this.answerFlag1) {
                this.answerFlag1 = true
                this.answerCount++
            }
        },

        get_list(flag) {
            this.loading = true
            this.$http.post('/api/game/list', this.filterData).then(res => {
                this.list = res.data;
                this.total = res.total
                this.lastPage = res.last_page
                if (flag) this.dialogVisible1 = true
                this.loading = false
                localStorage.setItem('game_filter_data', JSON.stringify(this.filterData))
            });
        },
        get_words() {
            this.loading = true
            this.source = this.list[this.source_index];
            this.$http.post('/api/game/detail', { id: this.source.id }).then(info => {
                this.set_sections(info)
                this.refresh()
                this.loading = false
            });
        },
        set_sections(info) {
            const sections = []
            const words = []
            info.chunks.forEach(chunk => {
                chunk.words.forEach(word => {
                    words.push(word)
                    if (this.setting.level == '初级') {
                        sections.push({
                            meaning: word.meaning + (word.extra ? `(${word.extra})` : ''),
                            words: [word]
                        })
                    }
                })
                if (this.setting.level == '初级' || this.setting.level == '中级') {
                    sections.push({
                        meaning: chunk.meaning,
                        words: chunk.words
                    })
                }
            })
            sections.push({
                meaning: info.meaning,
                words: words
            })
            this.sections = sections
        }
    },
};
</script>

<style scoped>
/* 拼写错误：波浪下划线 + 抖动动画 */
.shake {
    animation: shake 0.1s ease-in-out;
}

/* 左右轻微抖动 */
@keyframes shake {
    0% {
        transform: translateX(0px);
    }

    25% {
        transform: translateX(-6px);
    }

    75% {
        transform: translateX(6px);
    }

    100% {
        transform: translateX(0px);
    }
}
</style>